<template>
  <v-data-table
    :headers="headers"
    :items="items"
    :total-items="total"
    :rows-per-page-items="[5, 10, 25]"
    :pagination="pagination"
    :loading="loading"
    class="elevation-1"
    @update:pagination="$emit('update:pagination', $event)"
  >
    <template #items="{ item, index }">
      <td class="text-xs-right">{{ offset + index + 1 }}</td>
      <td>{{ item.name || '-' }}</td>
      <td>
        <v-container fluid grid-list-md class="ma-0 pa-0" :style="{ width: '100% !important' }">
          <v-layout>
            <v-flex shrink>
              <v-btn icon small outline class="ma-0" @click="$emit('edit', item)">
                <v-icon small>edit</v-icon>
              </v-btn>
            </v-flex>
            <v-flex shrink>
              <v-btn icon small outline color="error" class="ma-0" @click="$emit('delete', item)">
                <v-icon small>delete</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </td>
    </template>
  </v-data-table>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => []
    },
    total: {
      type: Number,
      default: 0
    },
    pagination: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      headers: [
        { text: this.$t('no.'), sortable: false, align: 'right' },
        { text: this.$t('Department'), sortable: false },
        { text: this.$t('Action'), sortable: false }
      ]
    }
  },
  computed: {
    offset() {
      return (this.pagination.page - 1) * this.pagination.rowsPerPage
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/view/template/tigerpoly/reporting/department/DepartmentTable.vue